// extracted by mini-css-extract-plugin
export var active = "_9j-7";
export var container = "_9j-0";
export var evenWidth = "_9j-4";
export var large = "_9j-5";
export var outlet = "_9j-8";
export var slide = "_9j-2";
export var small = "_9j-6";
export var tab = "_9j-3";
export var tabs = "_9j-1";